export const inactiveTooltipMsg =
  'You must save changes to perform this action';
